const defaultSEO = {}

export default defaultSEO
